import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import { IoIosArrowForward, IoMdAdd } from "react-icons/io";
import { AiFillHome } from "react-icons/ai";
import SearchBar from "../../../components/searchBar/SearchBar";
import Card from "../../../components/cards/Card";
import Table from "../../../components/tables/Table";
import Pagination from "../../../components/pagination/Pagination";
import Tab from "../../marketing/faqs/Tabs";
import Toast, { showSuccessToast } from "../../../components/toastify/Toast";
import showAlert from "../../../components/errorBoundries/Errors";
import { deleteMembersApi, getMembersApi } from "../../../services/apis/member";

const Members = () => {
  const navigate = useNavigate();
  const headers = ["Date", "Name", "Image", "Email", "Phone", "Role"];
  const keys = ["created_at", "name", "image", "email", "phone", "role"];
  const [modalIsOpen, setIsOpen] = useState(false);
  const [membersData, setMembersData] = useState({});
  const [faqsId, setFaqsId] = useState("");
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardData, setCardData] = useState([
    {
      icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#1C64F2" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.3998 12.8002C22.3998 12.3758 22.5684 11.9689 22.8684 11.6688C23.1685 11.3688 23.5755 11.2002 23.9998 11.2002C24.4242 11.2002 24.8311 11.3688 25.1312 11.6688C25.4312 11.9689 25.5998 12.3758 25.5998 12.8002V21.6002C25.5998 21.8124 25.6841 22.0159 25.8341 22.1659C25.9841 22.3159 26.1876 22.4002 26.3998 22.4002C26.612 22.4002 26.8155 22.3159 26.9655 22.1659C27.1155 22.0159 27.1998 21.8124 27.1998 21.6002V14.4002C27.1998 13.9758 27.3684 13.5689 27.6684 13.2688C27.9685 12.9688 28.3755 12.8002 28.7998 12.8002C29.2242 12.8002 29.6311 12.9688 29.9312 13.2688C30.2312 13.5689 30.3998 13.9758 30.3998 14.4002V21.6002C30.3998 21.8124 30.4841 22.0159 30.6341 22.1659C30.7841 22.3159 30.9876 22.4002 31.1998 22.4002C31.412 22.4002 31.6155 22.3159 31.7655 22.1659C31.9155 22.0159 31.9998 21.8124 31.9998 21.6002V17.6002C31.9998 17.1758 32.1684 16.7689 32.4684 16.4688C32.7685 16.1688 33.1755 16.0002 33.5998 16.0002C34.0242 16.0002 34.4311 16.1688 34.7312 16.4688C35.0312 16.7689 35.1998 17.1758 35.1998 17.6002V25.6002C35.1998 27.071 34.9101 28.5274 34.3473 29.8862C33.7844 31.2451 32.9594 32.4798 31.9194 33.5198C30.8794 34.5598 29.6447 35.3848 28.2859 35.9476C26.927 36.5105 25.4706 36.8002 23.9998 36.8002C22.529 36.8002 21.0726 36.5105 19.7138 35.9476C18.3549 35.3848 17.1202 34.5598 16.0802 33.5198C15.0402 32.4798 14.2152 31.2451 13.6524 29.8862C13.0895 28.5274 12.7998 27.071 12.7998 25.6002V22.4002C12.7998 21.9758 12.9684 21.5689 13.2684 21.2688C13.5685 20.9688 13.9755 20.8002 14.3998 20.8002C14.8242 20.8002 15.2311 20.9688 15.5312 21.2688C15.8312 21.5689 15.9998 21.9758 15.9998 22.4002V26.4002C15.9998 26.6124 16.0841 26.8159 16.2341 26.9659C16.3841 27.1159 16.5876 27.2002 16.7998 27.2002C17.012 27.2002 17.2155 27.1159 17.3655 26.9659C17.5155 26.8159 17.5998 26.6124 17.5998 26.4002V14.4002C17.5998 13.9758 17.7684 13.5689 18.0684 13.2688C18.3685 12.9688 18.7755 12.8002 19.1998 12.8002C19.6242 12.8002 20.0311 12.9688 20.3312 13.2688C20.6312 13.5689 20.7998 13.9758 20.7998 14.4002V21.6002C20.7998 21.8124 20.8841 22.0159 21.0341 22.1659C21.1841 22.3159 21.3876 22.4002 21.5998 22.4002C21.812 22.4002 22.0155 22.3159 22.1655 22.1659C22.3155 22.0159 22.3998 21.8124 22.3998 21.6002V12.8002Z" fill="white" />
      </svg>,
      title: "Total Members",
      count: "--",
    },
  ]);
  const pageSize = 10;

  useEffect(() => {
    fetchData("");
  }, []);

  const fetchData = async (query) => {
    try {
      const respones = await getMembersApi("?search=" + query);
      if (respones?.status === 200) {
        setMembersData(respones?.data);
        setCardData([
          {
            icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="48" height="48" rx="8" fill="#1C64F2" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M22.3998 12.8002C22.3998 12.3758 22.5684 11.9689 22.8684 11.6688C23.1685 11.3688 23.5755 11.2002 23.9998 11.2002C24.4242 11.2002 24.8311 11.3688 25.1312 11.6688C25.4312 11.9689 25.5998 12.3758 25.5998 12.8002V21.6002C25.5998 21.8124 25.6841 22.0159 25.8341 22.1659C25.9841 22.3159 26.1876 22.4002 26.3998 22.4002C26.612 22.4002 26.8155 22.3159 26.9655 22.1659C27.1155 22.0159 27.1998 21.8124 27.1998 21.6002V14.4002C27.1998 13.9758 27.3684 13.5689 27.6684 13.2688C27.9685 12.9688 28.3755 12.8002 28.7998 12.8002C29.2242 12.8002 29.6311 12.9688 29.9312 13.2688C30.2312 13.5689 30.3998 13.9758 30.3998 14.4002V21.6002C30.3998 21.8124 30.4841 22.0159 30.6341 22.1659C30.7841 22.3159 30.9876 22.4002 31.1998 22.4002C31.412 22.4002 31.6155 22.3159 31.7655 22.1659C31.9155 22.0159 31.9998 21.8124 31.9998 21.6002V17.6002C31.9998 17.1758 32.1684 16.7689 32.4684 16.4688C32.7685 16.1688 33.1755 16.0002 33.5998 16.0002C34.0242 16.0002 34.4311 16.1688 34.7312 16.4688C35.0312 16.7689 35.1998 17.1758 35.1998 17.6002V25.6002C35.1998 27.071 34.9101 28.5274 34.3473 29.8862C33.7844 31.2451 32.9594 32.4798 31.9194 33.5198C30.8794 34.5598 29.6447 35.3848 28.2859 35.9476C26.927 36.5105 25.4706 36.8002 23.9998 36.8002C22.529 36.8002 21.0726 36.5105 19.7138 35.9476C18.3549 35.3848 17.1202 34.5598 16.0802 33.5198C15.0402 32.4798 14.2152 31.2451 13.6524 29.8862C13.0895 28.5274 12.7998 27.071 12.7998 25.6002V22.4002C12.7998 21.9758 12.9684 21.5689 13.2684 21.2688C13.5685 20.9688 13.9755 20.8002 14.3998 20.8002C14.8242 20.8002 15.2311 20.9688 15.5312 21.2688C15.8312 21.5689 15.9998 21.9758 15.9998 22.4002V26.4002C15.9998 26.6124 16.0841 26.8159 16.2341 26.9659C16.3841 27.1159 16.5876 27.2002 16.7998 27.2002C17.012 27.2002 17.2155 27.1159 17.3655 26.9659C17.5155 26.8159 17.5998 26.6124 17.5998 26.4002V14.4002C17.5998 13.9758 17.7684 13.5689 18.0684 13.2688C18.3685 12.9688 18.7755 12.8002 19.1998 12.8002C19.6242 12.8002 20.0311 12.9688 20.3312 13.2688C20.6312 13.5689 20.7998 13.9758 20.7998 14.4002V21.6002C20.7998 21.8124 20.8841 22.0159 21.0341 22.1659C21.1841 22.3159 21.3876 22.4002 21.5998 22.4002C21.812 22.4002 22.0155 22.3159 22.1655 22.1659C22.3155 22.0159 22.3998 21.8124 22.3998 21.6002V12.8002Z" fill="white" />
            </svg>,
            title: "Total Members",
            count: respones?.data.count || 0,
          },
        ]);
      } else {
        let errors = "Opps! Something went wrong, please try again.";
        showAlert("Error", errors, "error");
      }
    } catch (error) {
      let errors =
        error?.response?.data?.detail ||
        "Opps! Something went wrong, please try again.";
      showAlert("Error", errors, "error");
    }
  };

  const openModal = (row) => {
    setIsOpen(true);
    setFaqsId(row?.id);
    setIsConfirmDelete(false);
  };

  const closeModal = () => {
    setIsOpen(false);
    setIsConfirmDelete(false);
  };
  useEffect(() => {
    if (isConfirmDelete === true) {
      const fetchData = async () => {
        try {
          const respones = await deleteMembersApi(faqsId);
          if (respones?.status === 204) {
            try {
              const respones = await getMembersApi();
              if (respones?.status === 200) {
                setMembersData(respones?.data);
              } else {
                let errors = "Opps! Something went wrong, please try again.";
                showAlert("Error", errors, "error");
              }
            } catch (error) {
              let errors =
                error?.response?.data?.detail ||
                "Opps! Something went wrong, please try again.";
              showAlert("Error", errors, "error");
            }
            setIsOpen(false);
            showSuccessToast("Member deleted successfully!");
          } else {
            let errors = "Opps! Something went wrong, please try again.";
            showAlert("Error", errors, "error");
          }
        } catch (error) {
          let errors =
            error?.response?.data?.detail ||
            "Opps! Something went wrong, please try again.";
          showAlert("Error", errors, "error");
        }
      };
      fetchData();
    }
  }, [isConfirmDelete]);
  // const handleEdit = (rowData) => {
  // navigate(`/faqs/edit-faqs`, { state: { rowData } });
  // };

  const extraColumnRenderer = (row) => (
    <div className="flex space-x-2">
      {/* <FiEdit
        size={23}
        onClick={() => handleEdit(row)}
        className="cursor-pointer text-primary"
      /> */}
      <MdDelete
        size={25}
        onClick={() => openModal(row)}
        className="cursor-pointer text-red-600"
      />
    </div>
  );
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSearch = (query) => {
    fetchData(query);
  };

  return (
    <div className="">
      <Toast />
      {/* Top Section Begin */}
      <div className="flex gap-3 items-center font-medium text-gray-500">
        <AiFillHome />
        <p>Home</p>
        <IoIosArrowForward />
        <p>Members</p>
      </div>
      {/* Top Section End */}
      {/* Add Faqs Begin */}
      <div className="flex justify-between pt-3">
        <div className="w-[30%]">
          <SearchBar placeholder="Search in Members..." onSearch={handleSearch} />
        </div>
        <div>
          <Link to="/members/add">
            <button
              type="button"
              className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-md w-full px-3 py-2.5 text-center flex items-center gap-1"
            >
              <IoMdAdd style={{ color: "white" }} size={23} />
              Add Member
            </button>
          </Link>
        </div>
      </div>
      {/* Add Faqs End */}
      {/* Card Section Begin */}
      <div className="py-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
          {cardData.map((card, index) => (
            <Card title={card.title} count={card.count} icon={card.icon} />
          ))}
        </div>
      </div>
      {/* Card Section End */}
      {/* Tabs Section Begin */}
      <div className="lg:pl-2">
        <Tab />
      </div>
      {/* Tabs Section End */}
      {/* Table Begin */}
      <div className="mt-2">
        <Table
          headers={headers}
          keys={keys}
          rows={membersData?.results}
          extraColumn="Actions"
          extraColumnRenderer={extraColumnRenderer}
        />
      </div>
      {/* Table End */}
      {/* Pagination Begin */}
      <div className="xl:pl-5 pl-0">
        <Pagination
          currentPage={currentPage}
          totalPages={Math.ceil(membersData?.count / pageSize)}
          pageSize={pageSize}
          totalEntries={membersData?.count}
          onPageChange={handlePageChange}
          data={membersData}
          setData={setMembersData}
        />
      </div>
      {/* Pagination End */}
    </div>
  );
};

export default Members;
